export default {"src":"/_next/static/image/public/images/ic_pdf.0b27fc58a16b14492b33f07c2b5820f1.svg","height":31,"width":24};